import { render, staticRenderFns } from "./AreaRule.vue?vue&type=template&id=1aa03a51&scoped=true"
import script from "./AreaRule.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AreaRule.vue?vue&type=style&index=0&id=1aa03a51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa03a51",
  null
  
)

export default component.exports